import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { saveApprovers } from '../../../../../redux/slices/invoicing';
import { useDispatch } from '../../../../../redux/store';
import { AwaitButton } from '../../../../../reusable-components/await-button';
import Iconify from '../../../../../reusable-components/iconify';
import { useSnackbar } from '../../../../../reusable-components/snackbar';
import { useCanUpdateApprovers } from '../reusable/hooks/useInvoiceLocks';

SubmitApprovers.propTypes = {
  selectedApprovers: PropTypes.any,
  goToNext: PropTypes.any,
  withDuplicateCheck: PropTypes.func,
  glRows: PropTypes.array,
};
export default function SubmitApprovers({ selectedApprovers, goToNext, withDuplicateCheck, glRows }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { canUpdateApprovers, message } = useCanUpdateApprovers(glRows);

  const handleSaveApprovers = async () => {
    withDuplicateCheck(async () => {
      setIsSubmitting(true);
      const response = await dispatch(saveApprovers(id, selectedApprovers));
      if (response.data?.success) goToNext();
      enqueueSnackbar(response.data.message, { variant: response.data.success ? 'success' : 'error' });
      setIsSubmitting(false);
    }, 'Send for approval');
  };

  return (
    <>
      <Tooltip
        title={
          !canUpdateApprovers
            ? message
            : 'Sends this invoice to designated approvers for review. Once approved, it can be submitted to the accounting system.'
        }
        placement="top"
        arrow
      >
        <Box>
          <AwaitButton
            variant="contained"
            color="secondary"
            onClick={handleSaveApprovers}
            loading={isSubmitting}
            loadingPosition="start"
            disabled={!canUpdateApprovers}
            startIcon={<Iconify icon="material-symbols:order-approve-outline-sharp" />}
            size="small"
          >
            Send for approval
          </AwaitButton>
        </Box>
      </Tooltip>
    </>
  );
}
